export const standardPasswordRules = [
  'Mix letters and numbers.',
  'At least 8 characters long',
];
